// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import App from "./App";
import Authentication from "@/components/Authentication.vue";
import Login from "@/components/Login.vue";
import CreateAccount from "@/components/CreateAccount.vue";
import Quotes from "@/components/Quotes";
import Account from "@/components/Account";
import AddToQuote from "./components/AddToQuote.vue";
import QuoteCart from "./components/QuoteCart.vue";
import QuoteViewer from "./components/QuoteViewer.vue";
import QuoteFullView from "./components/QuoteFullView.vue";
import Confirmation from "./components/Confirmation.vue";
import ChangePassword from "./components/ChangePassword.vue";
import Financing from "./components/Financing.vue";

Vue.component("auth", Authentication);
Vue.component("login", Login);
Vue.component("createAccount", CreateAccount);
Vue.component("quotes", Quotes);
Vue.component("account", Account);
Vue.component("add-to-quote", AddToQuote);
Vue.component("quote-cart", QuoteCart);
Vue.component("quote-viewer", QuoteViewer);
Vue.component("quote-full-view", QuoteFullView);
Vue.component("confirmation", Confirmation);
Vue.component("change-password", ChangePassword);
Vue.component("financing", Financing);

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    // Format Dates to MM, D, Y
    formatDate: function(date) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];

      // Check for valid date
      if (isNaN(Date.parse(date)) === false) {
        var formatDate = new Date(date);
      } else if (typeof date === "number") {
        if (date.toString().length === 10) {
          var formatDate = new Date(date * 1000);
        } else {
          var formatDate = new Date(date);
        }
      } else {
        return date;
      }

      return `${
        monthNames[formatDate.getMonth()]
      } ${formatDate.getDate()}, ${formatDate.getFullYear()}`;
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data: {
    currentUser: {
      name: "",
      guest: null,
      uid: ""
    },
    activeDraft: "",
    activeQuote: "",
    currentState: "quotes",
    currentPage: "",
    fullView: false,
    currentVersion: process.env.VUE_APP_VERSION,
    currentSite: defineSite(),
    env: process.env.NODE_ENV,
    open: false,
    confirmation: {
      open: false,
      msg: "",
      returnState: "",
      returnMsg: "",
      processing: false
    }
  },
  components: { App },
  template: "<App/>"
});

function defineSite() {
  let URL = window.location.hostname;

  if (URL.indexOf("mitylite") > -1) {
    return "MityLite";
  } else if (URL.indexOf("bertolini") > -1) {
    return "Bertolini";
  } else if (URL.indexOf("holsag") > -1) {
    return "Holsag";
  } else if (URL.indexOf("broda") > -1) {
    return "Broda";
  } else {
    return "MityLite";
  }
}

//IE11 Foreach Fix
if (typeof NodeList.prototype.forEach !== "function") {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
